/**
 * Lab Countdown Timer
 * 
 * Manages countdown timer functionality for the countdown timer block.
 * Updates the timer display every second with days, hours, minutes, and seconds.
 */

(function() {
  'use strict';

  const timers = new Map();

  function parseDate(dateString) {
    if (!dateString || !dateString.trim()) {
      return null;
    }
    
    // Parse date string in format: YYYY-MM-DD HH:MM:SS
    // Handle both with and without time
    const parts = dateString.trim().split(' ');
    const datePart = parts[0];
    const timePart = parts[1] || '00:00:00';
    
    const dateMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!dateMatch) {
      console.warn('LabCountdownTimer: Invalid date format:', dateString);
      return null;
    }
    
    const [, year, month, day] = dateMatch.map(Number);
    const timeMatch = timePart.match(/^(\d{2}):(\d{2}):(\d{2})$/);
    
    if (!timeMatch) {
      console.warn('LabCountdownTimer: Invalid time format:', dateString);
      return null;
    }
    
    const [, hours, minutes, seconds] = timeMatch.map(Number);
    
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  function updateTimer(timerId) {
    const timer = timers.get(timerId);
    if (!timer) return;

    const { container, startDate, endDate } = timer;
    const now = new Date();

    // Check if timer should start
    if (startDate && now < startDate) {
      updateDisplay(container, 0, 0, 0, 0);
      return;
    }

    // Calculate time difference
    const diff = endDate - now;

    if (diff <= 0) {
      // Timer has ended
      updateDisplay(container, 0, 0, 0, 0);
      clearInterval(timer.intervalId);
      timers.delete(timerId);
      return;
    }

    // Calculate days, hours, minutes, seconds
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    updateDisplay(container, days, hours, minutes, seconds);
  }

  function updateDisplay(container, days, hours, minutes, seconds) {
    const daysEl = container.querySelector('[data-days]');
    const hoursEl = container.querySelector('[data-hours]');
    const minutesEl = container.querySelector('[data-minutes]');
    const secondsEl = container.querySelector('[data-seconds]');

    if (daysEl) daysEl.textContent = days;
    if (hoursEl) hoursEl.textContent = hours;
    if (minutesEl) minutesEl.textContent = minutes;
    if (secondsEl) secondsEl.textContent = seconds;
  }

  function initTimer(container) {
    const timerId = container.id || `timer-${Date.now()}-${Math.random()}`;
    const display = container.querySelector('.lab-countdown-timer__display');
    
    if (!display) {
      console.warn('LabCountdownTimer: Display element not found');
      return;
    }

    const startDateStr = display.dataset.startDate;
    const endDateStr = display.dataset.endDate;

    if (!endDateStr) {
      console.warn('LabCountdownTimer: No end date provided');
      return;
    }

    // Parse dates
    const endDate = parseDate(endDateStr);
    if (!endDate) {
      console.warn('LabCountdownTimer: Invalid end date');
      return;
    }

    const startDate = startDateStr ? parseDate(startDateStr) : null;

    // Check if timer should be active
    const now = new Date();
    
    if (startDate && now < startDate) {
      // Timer hasn't started yet
      updateDisplay(container, 0, 0, 0, 0);
      return;
    }

    if (now >= endDate) {
      // Timer has ended
      updateDisplay(container, 0, 0, 0, 0);
      return;
    }

    // Store timer info
    const intervalId = setInterval(() => updateTimer(timerId), 1000);
    timers.set(timerId, {
      container,
      startDate,
      endDate,
      intervalId
    });

    // Initial update
    updateTimer(timerId);
  }

  function initAllTimers() {
    const timerContainers = document.querySelectorAll('.lab-countdown-timer');
    timerContainers.forEach(container => {
      if (!container.id) {
        container.id = `lab-countdown-timer-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      }
      initTimer(container);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTimers);
  } else {
    initAllTimers();
  }

  // Re-initialize on section re-render (for Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllTimers);
  }
})();


